import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-report-editabletext-import-confirm",
  styleUrls: ["./inspection-report-edit-text-import-confirm-dialog.component.scss"],
  templateUrl: "./inspection-report-edit-text-import-confirm-dialog.component.html",
  standalone: false
})
export class ReportEditableTextImportConfirmDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ReportEditableTextImportConfirmDialogComponent, { result: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  confirm(): void {
    this.dialogRef.close({ result: true });
  }
}
